import React from 'react';
import simple from 'react-simple/inline';
import {LOGO_FILENAME} from 'config';

const Container = simple('div', {
	backgroundColor: 'white',
	padding: 20,
	fontFamily: 'Helvetica',
	marginBottom: '20px',
	maxWidth: '1024px',
	paddingTop: 5,
});

const Row = simple('div', {
	paddingTop: 10,
});

const AddressBox = simple('div', {
	marginLeft: 20,
	display: 'inline-block',
	verticalAlign: 'middle',
});

const Link = simple('a', {
	color: '#222',
	display: 'inline-block',
});

const Separator = simple('span', {
	borderLeft: '1px solid #222',
	marginLeft: 10,
	marginRight: 10,
	height: 16,
});

const Image = simple('img', {
	width: '98px',
	height: '98px',
	display: 'inline-block',
});

const ClientEmail = ({clientFirstName, clientLastName}) => {
	const name =
		clientFirstName && clientLastName ? `${clientFirstName} ${clientLastName}` : '';

	return (
		<Container>
			{name ? <p>Dear {name},</p> : null}
			<p>Thank you very much for your interest in our products!</p>
			<p>
				Please find attached the report of your Sleipner E series benefit calculator. Our
				team is looking into your request in detail, and will get back to you as soon as
				possible.
			</p>
			<Row>
				<table>
					<tr>
						<td>
							<Image src={`cid:${LOGO_FILENAME}`} />
						</td>
						<td>
							<AddressBox>
								<div>Sleipner Finland Oy</div>
								<div>Puistokatu 2</div>
								<div>40100 JYVÄSKYLÄ</div>
								<div>FINLAND</div>
							</AddressBox>
						</td>
					</tr>
				</table>
			</Row>
			<Row>
				<Link href="https://www.facebook.com/SleipnerFI">Facebook</Link>
				<Separator />
				<Link href="https://www.instagram.com/sleipnerfinland/?hl=en">Instagram</Link>
				<Separator />
				<Link href="https://www.linkedin.com/company/sleipner-finland-oy/?viewAsMember=true">
					LinkedIn
				</Link>
				<Separator />
				<Link href="https://www.youtube.com/channel/UCTQvldSfYps41S32lu5OaUw">
					Youtube
				</Link>
				<Separator />
				<Link href="http://www.sleipner.com/">www.sleipner.com</Link>
			</Row>
		</Container>
	);
};

export const getPlainTextEmail = () => {
	return 'Thank you very much for your interest in our products! Please find attached the report of your Sleipner E series benefit calculator.';
};

export default ClientEmail;
